module.exports = __webpack_public_path__ + "img/20.b871e228.png";